import { useRef } from 'react'
import { FULL_VOLUME, useSelectedAudioVolumeUpdatesHandler } from '../../hooks'

import { Text } from 'common-components'
import { RangeSlider } from 'common-components'
import VolumeIcon from 'assets/svgr-icons/Volume.svg'
import VolumeMuteIcon from 'assets/svgr-icons/VolumeMute.svg'
import { memo } from 'react'

import * as Styled from './styled'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'

const VolumeSlider = () => {
  const { volume, onChangeVolume } = useSelectedAudioVolumeUpdatesHandler()
  const volumeBeforeMuteRef = useRef(volume || FULL_VOLUME)
  const isMuted = volume === 0

  const toggleMute = () => {
    if (isMuted) {
      onChangeVolume(volumeBeforeMuteRef.current || FULL_VOLUME)
    } else {
      volumeBeforeMuteRef.current = volume || FULL_VOLUME
      onChangeVolume(0)
    }
  }

  return (
    <Styled.VolumeSliderContainer>
      <Text type="h2">{translate(T.VOLUME)}</Text>
      <Styled.VolumeSliderWrapper>
        <Styled.MuteButton
          type="button"
          onClick={toggleMute}
          aria-label={translate(T.VOLUME)}
        >
          {isMuted ? <VolumeMuteIcon /> : <VolumeIcon />}
        </Styled.MuteButton>

        <RangeSlider
          onChange={event => {
            const value = parseFloat(event.target.value)
            onChangeVolume(value)
          }}
          isFullWidth
          value={volume}
        />

        <Styled.VolumePercent type="h4" color="secondaryDark">
          {volume}%
        </Styled.VolumePercent>
      </Styled.VolumeSliderWrapper>
    </Styled.VolumeSliderContainer>
  )
}

export default memo(VolumeSlider)
